<template>
  <el-dialog
    :title="$t('privateNetInstance.tip')"
    :visible.sync="dialogVisible"
    class="cps-dialog-icon-line-height result-dialog" :close-on-click-modal="false"
    custom-class="result-ip">
    <p>
      <i class="jc-icon-my-check-circle success-icon"></i>
      <span class="result-text">
        {{$t('subnet.help.addAliasSuccess', [successDataList.length])}}
      </span>
      <br/>
      <span>
        {{successListString.substring(0, successListString.length - 1)}}
      </span>
    </p>
    <p style="margin-top:20px">
      <i class="jc-icon-my-times-circle error-icon"></i>
      <span class="result-text">
        {{$t('subnet.help.addAliasFail', [failDataList.length])}}
      </span>
      <br/>
      <span>
       {{failListString.substring(0, failListString.length - 1)}}
      </span>
    </p>
    <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: this.resultDialogVisible,
    };
  },
  props: {
    // 成功数据列表
    successDataList: {
      type: Array,
    },
    // 失败数据列表
    failDataList: {
      type: Array,
    },
    resultDialogVisible: {
      type: Boolean
    }
  },
  watch: {
    resultDialogVisible(newVal) {
      this.dialogVisible = newVal;
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  },
  computed: {
    successListString() {
      let tempString = '';
      for (const item of this.successDataList) {
        tempString += item.cidr + ';';
      }
      return tempString;
    },
    failListString() {
      let tempString = '';
      for (const item of this.failDataList) {
        tempString += item.cidr + ';';
      }
      return tempString;
    }
  }
};
</script>
<style lang="scss">
  .result-dialog{
    .result-text{
      color: #212121
    }
    .success-icon{
      color: #5fe7cb
    }
    .error-icon{
      color: red
    }
    .el-dialog{
      width: 500px !important
    }

    .result-ip {
      .jc-dialog__body{
        height: 150px;
        overflow: auto;
        overflow-x: hidden;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/aliasIpAddResult/AliasIpAddResult.vue